// ─────────────────────────────────────────────────────────────────────────────
// MOCK DATA TOGGLE
//
// ✅ USE_MOCK = true  → Saare API calls mock data return karenge (backend ki
//                       zaroorat nahi, offline testing ke liye)
//
// ❌ USE_MOCK = false → Saare API calls real backend se data fetch karenge
//
// SIRF YEH EK LINE BADLO — baaki poora project automatically switch ho jaega.
// ─────────────────────────────────────────────────────────────────────────────

export const USE_MOCK = false;

// ─────────────────────────────────────────────────────────────────────────────
// DEMO MODE — mock data WITHOUT touching the global USE_MOCK flag.
//
// Active only when ONE of these is true (otherwise everything behaves normally):
//   1. window.__VISTAAR_DEMO__  → set by the store ONLY for ?demo=1 documents
//      (the hero-laptop preview iframes — never the real app's top window)
//   2. URL has ?demo=1          → hero-laptop preview iframes
//   3. sessionStorage "vistaarDemo" → "Explore Live Demo" session. Set when a
//      demo account logs in and CLEARED on every real login / logout (authSlice),
//      so it can never leak into a real user's session.
//
// Real/production users are completely unaffected — they have no ?demo param and
// the sessionStorage flag is cleared the moment they log in.
// ─────────────────────────────────────────────────────────────────────────────
export function isDemoMode() {
  if (typeof window === "undefined") return false;
  try {
    if (window.__VISTAAR_DEMO__) return true;
    const qs = new URLSearchParams(window.location.search);
    if (qs.get("demo") === "1") return true;
    if (sessionStorage.getItem("vistaarDemo") === "1") return true;
  } catch (e) { /* ignore */ }
  return false;
}

// Effective switch used by the API layer.
export function mockEnabled() {
  return USE_MOCK || isDemoMode();
}
